import { Container} from "react-bootstrap";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import { useParams } from "react-router-dom";

import PostSingle from "./PostSingle"

const PostItem = () => {
  const {Id} = useParams();
  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Post", link: "/post", active: true },
    { label: Id , link: `/post/${Id}`, active: true }, 
  ];  

  return (
  <Container className="my-4"> 
    <BreadCrumb items={breadcrumbItems} />

    <PostSingle back={`/post`} />

  </Container> 

  );
}
export default PostItem;